import { Lock } from "lucide-react";

export function NoAccess({ what }) {
  return (
    <div className="grid h-full place-items-center p-8" data-testid="no-access">
      <div className="max-w-sm text-center">
        <Lock className="mx-auto h-8 w-8 text-slate-400" />
        <h1 className="mt-3 font-display text-2xl font-bold text-slate-900">No access</h1>
        <p className="mt-1 text-sm text-slate-500">You need the “add/edit products” permission to use {what}. Ask the owner.</p>
      </div>
    </div>
  );
}
